import Gallery from "../../components/Gallery/Gallery";
function Gallerie() {
  return (
    <>
      <Gallery />
    </>
  );
}

export default Gallerie;
